// extracted by css-extract-rspack-plugin
export default {"cardGridFrame":"FeaturedContent-module__cardGridFrame___LSo3"};